import PurchasesTable from '@/modules/shop/components/PurchasesTable'
import type { components } from '@/schema'

type Purchase = components['schemas']['AdminShopPurchaseResponse']

interface PurchasesListingProps {
	data: Purchase[]
	total: number
	isLoading: boolean
}

export default function PurchasesListing({
	data,
	total,
	isLoading,
}: PurchasesListingProps) {
	return (
		<div className="space-y-6">
			{/* Header and Stats */}
			<div className="space-y-4">
				<div className="flex items-center justify-between">
					<h2 className="text-2xl font-semibold">
						ประวัติการซื้อ ({total} รายการ)
					</h2>
				</div>
			</div>

			{/* Table */}
			<PurchasesTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
